const NVBUGS_PATHNAME = '/manage/nvbugs'
const NVQUAL_PATHNAME = '/manage/nvqualsubmissions'

export {
    NVBUGS_PATHNAME,
    NVQUAL_PATHNAME,
}